import { Order } from 'types/order';
export const licenseDisplayTerms = {
  standard: 'Standard',
  rental: 'Rent-to-own',
  annual: 'Annual',
  site: 'Site',
};
export type LicenseTerms = keyof typeof licenseDisplayTerms;
export type LicenseSeatActivation = {
  ID: number;
  AccountID: string | undefined | null;
  KeyCodeID: LicenseKeyCode['ID'] | undefined | null;
  MachineID: string | undefined | null;
  MachineName: string | undefined | null;
  ComputerModel: string | undefined | null;
  ComputerSerial: string | undefined | null;
  MachineUnavailable: boolean;
  EndDate: string;
  IsExpired: boolean;
  LastActivatedAtTimestamp: number;
  DisplayStatus: 'Active' | 'Remotely deactivated' | 'Deactivated' | 'Unknown';
  Note: string;
  InstalledBy: string;
  DeactivationDisabled: boolean;
};
export type LicenseSeat = {
  ID: number;
  Disposition: 'main' | 'backup' | 'edit';
  Activations: Array<LicenseSeatActivation>;
  DispositionDescription: string;
  FullDescription: string;
  AvailableInstallationCount: number;
};
export type LicenseKeyCode = {
  ID: number;
  LicenseSerial: string;
  Disposition: string;
  UserEmail: string;
  EndDate: string;
  IsDead: boolean;
  Code: string;
  AllowActivate: boolean;
  AllowDeactivate: boolean;
  Note: string;
};
export type LicenseDateRange = {
  Start: string;
  End: string;
};
export type LicenseType =
  | 'bundle'
  | 'audio+video'
  | 'audio+lighting'
  | 'video+lighting'
  | 'audio'
  | 'video'
  | 'lighting';
export type LicenseDisplayType =
  | 'Bundle'
  | 'Audio+Video'
  | 'Audio+Lighting'
  | 'Video+Lighting'
  | 'Audio'
  | 'Video'
  | 'Lighting';
export type Sublicense = {
  AccountID: number;
  AppName: string;
  // "QLab"
  AppVersion: number;
  // 4
  Terms: LicenseTerms;
  Tier: string;
  // "bundle"
  Serial: string;
  // "Q1812061805JKVLYP3"
  Type: LicenseType;
  DisplayType: LicenseDisplayType;
  IsDead: boolean;
  DateRange: LicenseDateRange | undefined | null;
  Seats: Array<LicenseSeat>;
  KeyCodes: Array<LicenseKeyCode>;
};
export type License = {
  ID: number;
  AccountID: number;
  OrderID: Order['ID'];
  TradeInOrderID: Order['ID'];
  AppName: string;
  // "QLab"
  AppVersion: number;
  // 4
  Terms: LicenseTerms;
  Tier: string;
  // "bundle"
  Serial: string;
  // "Q1812061805JKVLYP3"
  Type: LicenseType;
  DisplayType: LicenseDisplayType;
  IsDead: boolean;
  DateRange: LicenseDateRange | undefined | null;
  Seats: Array<LicenseSeat>;
  KeyCodes: Array<LicenseKeyCode>;
  Sublicenses: Array<License>;
  TradeInValue: number;
  DisplayTradeInValue: string;
  Note: string;
  ViewingAsAdmin: boolean;
  CreatedAt: Date;
};
export function licenseIsEligibleForTradeIn(license: License): boolean {
  return (
    (license.Terms === 'standard' || license.Terms === 'rental') &&
    license.AppName === 'QLab' &&
    license.AppVersion > 3 &&
    license.TradeInValue > 0
  );
}
